import { render, staticRenderFns } from "./rfq-tab-file.vue?vue&type=template&id=73b0ec50"
import script from "./rfq-tab-file.vue?vue&type=script&lang=js"
export * from "./rfq-tab-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports